/* This is a mst-gql generated file, don't modify it manually */
/* eslint-disable */
/* tslint:disable */
// @ts-nocheck

import { types } from 'mobx-state-tree'
import { QueryBuilder } from 'mst-gql'
import { ModelBase } from './ModelBase'
import { LiveEventModel, LiveEventModelType } from './LiveEventModel'
import { LiveEventModelSelector } from './LiveEventModel.base'
import { RootStoreType } from './index'

/**
 * UserInfoBase
 * auto generated base class for the model UserInfoModel.
 */
export const UserInfoModelBase = ModelBase.named('UserInfo')
  .props({
    __typename: types.optional(types.literal('UserInfo'), 'UserInfo'),
    _id: types.identifier,
    createdAt: types.union(types.undefined, types.frozen()),
    isUserFromLiveEvent: types.union(types.undefined, types.null, types.boolean),
    isUserNew: types.union(types.undefined, types.boolean),
    myFirstGameFinish: types.union(types.undefined, types.null, types.boolean),
    questionAnswers: types.union(types.undefined, types.frozen()),
    updatedAt: types.union(types.undefined, types.frozen()),
    userEventRating: types.union(types.undefined, types.null, types.number),
    userId: types.union(types.undefined, types.frozen()),
    userLiveEvent: types.union(
      types.undefined,
      types.null,
      types.late(() => LiveEventModel)
    ),
    userVisitCount: types.union(types.undefined, types.null, types.number)
  })
  .views((self) => ({
    get store() {
      return self.__getStore<RootStoreType>()
    }
  }))

export class UserInfoModelSelector extends QueryBuilder {
  get _id() {
    return this.__attr('_id')
  }
  get createdAt() {
    return this.__attr('createdAt')
  }
  get isUserFromLiveEvent() {
    return this.__attr('isUserFromLiveEvent')
  }
  get isUserNew() {
    return this.__attr('isUserNew')
  }
  get myFirstGameFinish() {
    return this.__attr('myFirstGameFinish')
  }
  get questionAnswers() {
    return this.__attr('questionAnswers')
  }
  get updatedAt() {
    return this.__attr('updatedAt')
  }
  get userEventRating() {
    return this.__attr('userEventRating')
  }
  get userId() {
    return this.__attr('userId')
  }
  get userVisitCount() {
    return this.__attr('userVisitCount')
  }
  userLiveEvent(
    builder:
      | string
      | LiveEventModelSelector
      | ((selector: LiveEventModelSelector) => LiveEventModelSelector)
      | undefined
  ) {
    return this.__child('userLiveEvent', LiveEventModelSelector, builder)
  }
}
export function selectFromUserInfo() {
  return new UserInfoModelSelector()
}

export const userInfoModelPrimitives =
  selectFromUserInfo()._id.createdAt.isUserFromLiveEvent.isUserNew.myFirstGameFinish.questionAnswers.updatedAt
    .userEventRating.userId.userVisitCount
